import { CButton } from 'app/components/Common'
import { COLORS } from 'app/constants'
import React, { useState } from 'react'
import { View } from 'styles/reactnative'
import PopUpCreateModal from './PopUpCreateModal'

const PopUpCreate = () => {
	const [showModal, setShowModal] = useState(false)
	return (
		<View>
			<CButton
				title={'팝업 생성'}
				style={{
					background: COLORS.primary,
					color: COLORS.white,
					paddingBlock: 5,
					paddingInline: 15,
					whiteSpace: 'nowrap',
					alignSelf: 'flex-end',
				}}
				onClick={() => setShowModal(!showModal)}
			/>
			<PopUpCreateModal
				showModal={showModal}
				setShowModal={setShowModal}
			/>
		</View>
	)
}

export default PopUpCreate
